// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1419":"4ded1e85","2422":"29b986a5","4535":"eab724dd","8688":"31a80546","8731":"0c4f11a9"}[chunkId] + ".chunk.css";
};